import { CrossCountryRiskPage } from 'components/Pickers/CrossCountryRiskPicker';
import { HeatmapProvider } from 'components/Heatmap/HeatmapProvider';

export const Heatmap = () => {
    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                position: 'relative',
            }}>
            <div
                style={{
                    position: 'absolute',
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                }}>
                <div style={{ flex: 1, minHeight: 0 }}>
                    <HeatmapProvider />
                </div>
            </div>
        </div>
    );
};

export const HeatmapPage = () => {
    return (
        <CrossCountryRiskPage>
            <Heatmap />
        </CrossCountryRiskPage>
    );
};
